import twitterText from 'twitter-text'

const hasMentionsWithoutServer = (text: string): boolean => {
  const mentions = twitterText.extractMentions(text)
  return mentions.length > 0
}

const hasLinksWithoutProtocol = (text: string): boolean => {
  const allLinks = twitterText.extractUrlsWithIndices(text, {
    extractUrlsWithoutProtocol: true,
  })
  const linksWithProtocols = twitterText.extractUrlsWithIndices(text, {
    extractUrlsWithoutProtocol: false,
  })
  return allLinks.length > linksWithProtocols.length
}

export const MastodonParser = {
  hasMentionsWithoutServer,
  hasLinksWithoutProtocol,
}
